<template>
  <ComboboxGroup>
    <ComboboxSeparator v-if="divider" class="border-secondary border-t my-2" />
    <Component
      v-for="option in selectedOptions"
      @select.prevent
      @select="(event) => emit('select', event)"
      :checked="isChecked(option)"
      :is="isComponent"
      :key="option.id"
      :item="option"
      :value="option"
      class="group cursor-pointer text-style-sm mx-1.5 font-medium text-secondary rounded-sm flex items-center h-[40px] relative select-none data-[disabled]:text-disabled data-[disabled]:pointer-events-none data-[highlighted]:outline-none data-[highlighted]:bg-primary_hover data-[highlighted]:text-secondary_hover focus:text-secondary focus:bg-transparent"
    />
    <ComboboxSeparator
      v-if="!hideSeperator"
      class="border-secondary border-t my-2"
    />
    <Component
      v-for="option in deselectedOptions"
      @select.prevent
      @select="(event) => emit('select', event)"
      :checked="isChecked(option)"
      :is="isComponent"
      :key="option.id"
      :item="option"
      :value="option"
      class="group cursor-pointer text-style-sm mx-1.5 font-medium text-secondary rounded-sm flex items-center h-[40px] relative select-none data-[disabled]:text-disabled data-[disabled]:pointer-events-none data-[highlighted]:outline-none data-[highlighted]:bg-primary_hover data-[highlighted]:text-secondary_hover focus:text-secondary focus:bg-transparent"
    />
  </ComboboxGroup>
</template>

<script setup>
import { computed, toRef } from "vue";
import { ComboboxGroup, ComboboxSeparator } from "radix-vue";
import { isEmpty } from "lodash";
import {
  Default,
  Checkbox,
  Avatar,
  Dot,
  Icon,
  RadioButton,
} from "@/SharedComponents/Combobox/Inputs";
import { useFilterGroup } from "@/Composables/useFilterGroup";

const emit = defineEmits(["select"]);
const props = defineProps({
  modelValue: { type: Array, required: true },
  multiple: { type: Boolean, required: true },
  options: { type: Array, required: true },
  type: { type: String, required: true },
  handle: { type: String, required: true },
  divider: { type: Boolean, required: true },
});

const { selectedOptions, deselectedOptions } = useFilterGroup(
  toRef(() => ({
    multiple: props.multiple,
    options: props.options,
    modelValue: props.modelValue,
    handle: props.handle,
  }))
);

const isComponent = computed(() => {
  switch (props.type) {
    case "single":
      return RadioButton;
    case "checkbox":
      return Checkbox;
    case "icon":
      return Icon;
    case "avatar":
      return Avatar;
    case "dot":
      return Dot;
    default:
      return Default;
  }
});

const isChecked = (option) => {
  if (props.type === "date") {
    return false;
  }

  if (props.handle === "categories" && option.ids) {
    return option.ids.some((id) => props.modelValue.includes(id));
  }

  if (Array.isArray(props.modelValue)) {
    return props.modelValue.includes(option.id);
  }

  return props.modelValue === option.id;
};

const hideSeperator = computed(() => {
  return props.multiple
    ? isEmpty(selectedOptions.value) || isEmpty(deselectedOptions.value)
    : true;
});
</script>
